import { Send, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";

const XIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const SOCIALS = [
  {
    name: "FOLLOW ON X",
    sub: "@HALLOWIN COMMUNITY",
    href: "https://x.com/i/communities/1972316257106997599",
    Icon: XIcon,
    classes: "bg-[#B6FF00] text-black shadow-[0_0_30px_rgba(182,255,0,0.5)] hover:shadow-[0_0_50px_rgba(182,255,0,0.9)]",
    testid: "community-x-link",
    placeholder: false,
  },
  {
    name: "TELEGRAM",
    sub: "LINK DROPPING SOON",
    href: "#community",
    Icon: Send,
    classes: "bg-[#19002E] text-[#FF6B00] border-2 border-[#FF6B00]/60 shadow-[0_0_25px_rgba(255,107,0,0.3)] hover:bg-[#FF6B00] hover:text-black hover:shadow-[0_0_45px_rgba(255,107,0,0.8)]",
    testid: "community-telegram-link",
    placeholder: true,
  },
  {
    name: "DISCORD",
    sub: "LINK DROPPING SOON",
    href: "#community",
    Icon: MessageCircle,
    classes: "bg-[#19002E] text-[#A020F0] border-2 border-[#A020F0]/60 shadow-[0_0_25px_rgba(160,32,240,0.35)] hover:bg-[#A020F0] hover:text-white hover:shadow-[0_0_45px_rgba(160,32,240,0.85)]",
    testid: "community-discord-link",
    placeholder: true,
  },
];

export const Community = () => (
  <section id="community" className="relative z-10 py-20 lg:py-32 px-4 sm:px-8" data-testid="community-section">
    <div className="max-w-5xl mx-auto text-center">
      <Reveal>
        <p className="mono text-xs tracking-[0.35em] text-[#A020F0] glow-purple mb-4">// THE CULT</p>
        <h2 className="font-display font-bold uppercase text-3xl sm:text-4xl lg:text-5xl" data-testid="community-title">
          <span className="text-[#B6FF00] glow-green">THE HAUNTED</span>{" "}
          <span className="text-[#FF6B00] glow-orange">COMMUNITY</span>
        </h2>
        <p className="mono text-sm sm:text-base text-purple-200/75 mt-5" data-testid="community-subtitle">
          The party starts when the degens arrive.
        </p>
      </Reveal>

      <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-5 sm:gap-7">
        {SOCIALS.map(({ name, sub, href, Icon, classes, testid, placeholder }, i) => (
          <Reveal key={name} delay={i * 0.12}>
            <a
              href={href}
              target={placeholder ? undefined : "_blank"}
              rel={placeholder ? undefined : "noopener noreferrer"}
              data-testid={testid}
              className={`group flex items-center gap-4 rounded-2xl px-8 py-5 font-display font-bold uppercase tracking-wider transition-all duration-300 hover:scale-105 hover:-rotate-1 active:scale-95 ${classes}`}
            >
              <Icon className="w-7 h-7 group-hover:scale-125 group-hover:rotate-12 transition-transform duration-300" />
              <span className="text-left">
                <span className="block text-base sm:text-lg leading-tight">{name}</span>
                <span className="block mono text-[10px] tracking-[0.25em] opacity-70 font-normal">{sub}</span>
              </span>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
